(function () {
  console.log('[DEBUG] Starting smart polling for overflow control...');

  const POLL_INTERVAL = 200;
  const HEADER_SELECTOR = '.wt-header__aside';
  const DROPDOWN_SELECTOR = '.buckscc-select-styled';

  let lastState = null;

  const interval = setInterval(() => {
    const header = document.querySelector(HEADER_SELECTOR);
    const dropdown = document.querySelector(DROPDOWN_SELECTOR);

    if (!header || !dropdown) {
      console.warn('[DEBUG] Required element missing');
      return;
    }

    const isDropdownOpen = dropdown.classList.contains('active') && !dropdown.classList.contains('deactive');
    const newState = isDropdownOpen ? 'visible' : 'hidden';

    if (lastState !== newState) {
      header.style.setProperty('overflow', newState, 'important');
      header.setAttribute('data-overflow', newState);
      console.log(`[DEBUG] Overflow changed to: ${newState}`);
      lastState = newState;
    }
  }, POLL_INTERVAL);
})();


// CUSTOMIZE YOURS FORM STYLING

document.addEventListener("DOMContentLoaded", () => {
  const formContainer = document.querySelector(".shopify_form_container");
  if (!formContainer) return;

  const observer = new MutationObserver(() => {
    const form = document.querySelector("shopify-forms-embed");
    if (form) {
      observer.disconnect();
      const shadow = form.shadowRoot;
      if (shadow) {
        const sheet = new CSSStyleSheet();
        sheet.insertRule(`
          section._formContainer_1q1d2_30 {
            max-width: 536px !important;
          }
        `);
        sheet.insertRule(`
          section._formContainer_1q1d2_30 {
            span,label,p,div,option,select,button,legend,span._textBody_2aowh_10{
              font-family:Figtree, sans-serif !important;
            }
          }
        `);
        sheet.insertRule(`
          input._formInputField_nag3b_7,input._formPhoneInputField_piv1u_17,button._selectToggle_12thd_25 {
            border-radius: 50px !important;
          }
        `);
        sheet.insertRule(`
          section._formContainer_1q1d2_30 legend,div._birthdayText_rzr7e_15{
            font-size:16px;
            margin-block: 10px !important;
            padding-top: 10px;
            font-weight: 600;
          }
        `);
        sheet.insertRule(`
          section._formContainer_1q1d2_30 span._textBody_2aowh_10 {
            font-size: 16px;
          }
        `);
        sheet.insertRule(`
          button._formSubmitButton_cit2d_96 {
            text-transform: uppercase;
            border-radius: 50px;
            font-size: 17px;
            letter-spacing: 2px;
            width: fit-content;
            padding: 15px 40px;
            margin-top: 15px;
          }
        `);
        shadow.adoptedStyleSheets.push(sheet);
      }
      formContainer.classList.add("loaded");
    }
  });

  // Start observing outside the callback
  observer.observe(document.body, { childList: true, subtree: true });
});


